import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { KeyboardService } from '../../keyboard/keyboard.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.sass'],
})
export class InputTextComponent implements OnInit {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;

  @Input()
  mask: string;

  @Input()
  useCpfCnpjMask: boolean = false;

  @Input()
  typeCes?: TypeCesEnum | undefined;

  @Output()
  change = new EventEmitter<any>();

  @Output()
  blur = new EventEmitter<any>();

  keyboardChange: EventEmitter<any> = new EventEmitter<any>();
  private valueChangesSubscription: Subscription;

  public dynamicMask: string = '000.000.000-00';

  constructor(public keyboardService: KeyboardService) { }

  ngOnInit(): void {
    this.keyboardChange.subscribe((event) => {
      this.group.get(this.config.name)?.setValue(event);
    });

    const control = this.group.get(this.config.name);
    if (control) {
      if (this.useCpfCnpjMask && control.value) {
        this.applyMask(control.value, control);
      }

      this.valueChangesSubscription = control.valueChanges.subscribe(value => {
        this.onValueChange(value);
      });
    }
  }

  private applyMask(value: string, control: any): void {
    const rawValue = value.replace(/\D/g, '');
    const newMask = rawValue.length > 11 ? '00.000.000/0000-00' : '000.000.000-00';
    if (this.dynamicMask !== newMask) {
      this.dynamicMask = newMask;
      setTimeout(() => control.setValue(rawValue, { emitEvent: false }), 0);
    }
  }

  onValueChange(value: string | null): void {
    if (!this.useCpfCnpjMask || !value) {
      return;
    }
    const rawValue = value.replace(/\D/g, '');
    const newMask = rawValue.length > 11 ? '00.000.000/0000-00' : '000.000.000-00';
    if (this.dynamicMask !== newMask) {
      this.dynamicMask = newMask;
      const control = this.group.get(this.config.name);
      setTimeout(() => control?.setValue(rawValue, { emitEvent: false }), 0);
    }
  }

  onBlur(event: any): void {
    console.log('Input blur event:', event);
    console.log('Config:', this.config);
    if (this.config.onBlur) {
      console.log('Emitting blur event with config:', this.config);
      const value = this.group.get(this.config.name)?.value;
      console.log('Field value:', value);
      this.blur.emit({ field: this.config, form: this.group, value });
    }
  }
  ngOnDestroy(): void {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }
  onPaste(event: ClipboardEvent): void {
    if (!this.useCpfCnpjMask) {
      return;
    }
    const pasted = event.clipboardData?.getData('text') || '';
    const digits = pasted.replace(/\D/g, '');
    this.dynamicMask = digits.length > 11 ? '00.000.000/0000-00' : '000.000.000-00';
  }

  onKeyDown(event: KeyboardEvent): void {
    if (!this.useCpfCnpjMask) {
      return;
    }

    const control = this.group.get(this.config.name);
    if (!control) {
      return;
    }

    const rawValue = (control.value || '').replace(/\D/g, '');

    if (rawValue.length === 11 && /\d/.test(event.key)) {
      this.dynamicMask = '00.000.000/0000-00';
    }
  }
}